import trackingEventDictionary from "@core/dictionary/tracking-event";
import { BRAND } from "@core/brand/brand-config";
export const CLOUDINARY_INTEL_URL = "https://res.cloudinary.com/drzta9shk/image/upload/v1687950013/intel";
export const CLOUDINARY_INTEL_BASE_URL = "https://res.cloudinary.com/drzta9shk/image/upload";
export const saveSearchButtonType = {
  cancel: "cancel",
};

export const tabsEnum = [
  {
    name: BRAND.aiAssistantName,
    icon: <span className="material-symbols-outlined">auto_awesome</span>,
    pendo_event: trackingEventDictionary.hermesChatSidebarClick,
    id: "hermes_chat",
    link: "/hermes-chat",
    beta_icon: true,
  },
  {
    name: "Explore",
    icon: <span className="material-symbols-outlined">explore</span>,
    subItem: [
      {
        name: "Search Companies",
        icon: <span className="material-symbols-outlined">apartment</span>,
        pendo_event: trackingEventDictionary.companiesTabClick,
        link: "/company-search",
        id: "company_search",
        new_icon: false,
      },
      {
        name: "Find Buyers & Suppliers",
        icon: <span className="material-symbols-outlined">package_2</span>,
        pendo_event: trackingEventDictionary.newMay2026ProductTabClick,
        link: "/product-search",
        id: "product_search",
      },
      {
        name: "Find Shipments",
        icon: <span className="material-symbols-outlined">directions_boat</span>,
        pendo_event: trackingEventDictionary.menuAllShipments,
        id: "shipments",
      },
      {
        name: "AI Prospecting",
        icon: <span className="material-symbols-outlined">editor_choice</span>,
        pendo_event: trackingEventDictionary.intelHubTabClick,
        id: "intel_hub",
        link: "/ai-recommendations",
        beta_icon: false,
      },
    ],
  },
  {
    name: "Enrich",
    icon: <span className="material-symbols-outlined">auto_awesome</span>,
    subItem: [
      {
        name: "Workspace",
        link: "/workspace",
        count: true,
        count_key: "workspace_count",
        icon: <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1779362364/intel/misc/Task-Checklist--Streamline-Ultimate_1_xpor5n.svg" alt="workspace" className="tw-w-4 tw-h-4" />,
        pendo_event: trackingEventDictionary.workspaceSidebarClick,
        id: "workspace",
        new_icon: true,
      },
      {
        name: "HS Classifier",
        link: "/hs-classifier",
        icon: <span className="material-symbols-outlined">account_tree</span>,
        pendo_event: trackingEventDictionary.hsClassifierSidebarClick,
        id: "hs_classifier",
        new_icon: false,
      },
      {
        name: "Tariffs",
        link: "/compare-tariff",
        icon: <span className="material-symbols-outlined">balance</span>,
        pendo_event: trackingEventDictionary.compareTariffSidebarClick,
        id: "compare_tariff",
        new_icon: false,
      },
    ],
  },
  {
    name: "Bookmarks",
    icon: <span className="material-symbols-outlined">grade</span>,
    id: "bookmarks",
    subItem: [
      {
        name: "Companies",
        link: "/bookmarks/companies",
        icon: <span className="material-symbols-outlined">factory</span>,
        count: true,
        count_key: "companies_count",
        pendo_event: trackingEventDictionary.menuFavoriteCompanies,
        id: "bookmarks_companies",
      },
      {
        name: "Ports",
        link: "/bookmarks/ports",
        icon: <span className="material-symbols-outlined">anchor</span>,
        count: true,
        count_key: "trade_ports_count",
        access_key: "isPortProfile",
        pendo_event: trackingEventDictionary.menuFavoritePorts,
        id: "bookmarks_ports",
      },
      {
        name: "Shipments",
        link: "/bookmarks/shipments",
        icon: <span className="material-symbols-outlined">format_list_bulleted</span>,
        count: true,
        count_key: "shipments_count",
        pendo_event: trackingEventDictionary.menuFavoriteShipments,
        id: "bookmarks_shipments",
      },
    ],
  },
];

export const TabsResourceCenter = [
  {
    name: "Glossary",
    enum: "glossary",
    url: "/help-center?target=glossary",
    icon: <span className="material-symbols-outlined">dictionary</span>,
    isVisible: true,
  },
  {
    name: "FAQs",
    enum: "faqs",
    url: "/help-center?target=faqs",
    icon: <span className="material-symbols-outlined">contact_support</span>,
    isVisible: true,
  },
  {
    name: "Training Sessions",
    enum: "training-sessions",
    url: "/help-center?target=training-sessions",
    icon: <span className="material-symbols-outlined">animated_images</span>,
    isVisible: true,
  },
];
export const boltIconTooltipText = "Click here to know more.";
export const showNoDollar = {
  containerDescriptionRegion: true,
};

export const ERROR_MSG = "Something went wrong. Please try again later !!!";

export const profileType = {
  ports: "ports",
  logistics: "logistics",
  company: "company",
  tradeLanes: "tradeLanes",
  shipments: "shipments",
};

export const profileName = {
  ports: "Ports",
  logistics: "Logistics",
  company: "Companies",
  tradeLanes: "Trade Lanes",
  shipments: "Shipments",
};

export const noTags = "No Tags Added";

export const secondLevelRowsDropdown = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
];

export const dashboardTabsEnum = [
  {
    id: "request_center",
    name: "Request Center",
    link: "/dashboard/request-centre",
    pendoEvent: trackingEventDictionary.dashboardRequestCentre,
    iconEnum: "notifications",
    dataFor: "RequestCenterdash",
  },
  {
    id: "downloads",
    name: "Downloads",
    link: "/dashboard/downloads",
    pendoEvent: trackingEventDictionary.dashboardDownloads,
    iconEnum: "cloud_download",
    dataFor: "Downloadsdash",
  },
  {
    id: "contact_list",
    name: "Viewed Contacts",
    link: "/dashboard/address-book",
    pendoEvent: trackingEventDictionary.dashboardAddressBook,
    iconEnum: "contacts",
    dataFor: "ViewedContactsdash",
    count_key: "address_book_count",
  },
  {
    id: "data_updates",
    name: "Data Updates",
    hideOnGlobalPlan: true,
    link: "/dashboard/data-updates",
    pendoEvent: trackingEventDictionary.dashboardDataUpdates,
    iconEnum: "update",
    dataFor: "DataUpdatesdash",
  },
];

export const SHIPMENTS_NAV_ID = "shipments";

export const getNavLeaves = () => [...tabsEnum.flatMap((parent) => (parent.subItem || [parent]).flatMap((child) => (child.subItem?.length ? child.subItem : [child]))), ...dashboardTabsEnum];

export const getActiveNavItem = (pathname) => {
  const normalizedPathname = `/${pathname.split("/").filter(Boolean).join("/")}`.toLowerCase();
  return getNavLeaves()
    .filter((item) => item.link && (normalizedPathname === item.link || normalizedPathname.startsWith(`${item.link}/`)))
    .sort((a, b) => b.link.length - a.link.length)[0];
};

export const getSidebarLabel = (pathname) => getActiveNavItem(pathname)?.name.trim() ?? "";
